import { useContext, useEffect } from 'react';
import { isNextJs, isTouchwebInNextweb } from 'tradera/utils/nextjs';
import { RouterContext } from 'next/dist/shared/lib/router-context.shared-runtime';
import type { NextRouter } from 'next/router';

export const useOnNavigation = (onNavigation: () => void) => {
    const pagesRouter = useContext(RouterContext) as NextRouter;

    useEffect(() => {
        const handleRouteChange = () => {
            onNavigation();
        };

        // This only works for NextWeb
        if ((isNextJs || isTouchwebInNextweb) && pagesRouter?.events) {
            pagesRouter.events.on('routeChangeStart', handleRouteChange);
            return () => {
                pagesRouter.events.off('routeChangeStart', handleRouteChange);
            };
        }
    }, [onNavigation, pagesRouter]);
};
